const Noise = () => (
  <div
    aria-hidden="true"
    className="pointer-events-none fixed inset-0 z-[70] opacity-[0.05] mix-blend-multiply"
    style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.6'/%3E%3C/svg%3E")`,
    }}
  />
);

export default Noise;
